import React, { useEffect, useState } from 'react';
import { Menu, X, Truck } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/cfJQ2M88NC4RdEzfHL9tmR/logo-matambrito.png.jpg';
const navLinks = [{
  name: 'Inicio',
  href: '#inicio'
}, {
  name: 'Nosotros',
  href: '#nosotros'
}, {
  name: 'Servicios',
  href: '#servicios'
}, {
  name: 'Eventos',
  href: '#eventos'
}, {
  name: 'Espacios',
  href: '#espacios'
}, {
  name: 'Sucursales',
  href: '#sucursales'
}, {
  name: 'Galería',
  href: '#galeria'
}, {
  name: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const deliveryUrl = 'https://wa.me/5493417453398?text=Hola%2C+quiero+hacer+un+pedido+de+delivery+🍖';
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-matambrito-black/95 backdrop-blur-md shadow-lg py-2' : 'bg-transparent py-4'}`} data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <div className="flex justify-between items-center" data-id="element-266">
          {/* Logo */}
          <a href="#inicio" className="flex items-center gap-3 z-50" data-id="element-267">
            <img src={LOGO_URL} alt="El Matambrito" className="w-12 h-12 rounded-full object-cover border-2 border-matambrito-gold/30 shadow-lg" data-id="element-268" />
            <div className="hidden sm:block" data-id="element-269">
              <h1 className="font-serif font-bold text-xl leading-none text-matambrito-cream tracking-wide" data-id="element-270">
                El Matambrito
              </h1>
              <p className="text-matambrito-beige text-xs tracking-widest uppercase mt-1" data-id="element-271">
                By Leo y Mary
              </p>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-272">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-matambrito-cream/80 hover:text-matambrito-gold transition-colors" data-id="element-273">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex items-center gap-3" data-id="element-274">
            <a href="#contacto" className="bg-matambrito-red-fire hover:bg-matambrito-red-dark text-white px-5 py-2.5 rounded-md font-medium text-sm transition-colors shadow-lg shadow-matambrito-red-fire/20" data-id="element-275">
              Reservar Mesa
            </a>
            <a href={deliveryUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-5 py-2.5 rounded-md font-medium text-sm transition-colors shadow-lg shadow-amber-600/20" data-id="element-276">
              <Truck className="w-4 h-4" data-id="element-277" />
              Delivery
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden z-50 text-matambrito-cream p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-278">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-279" /> : <Menu className="w-6 h-6" data-id="element-280" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-281">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 bg-matambrito-black/98 backdrop-blur-xl z-40 lg:hidden pt-24 px-6 pb-32 overflow-y-auto" data-id="element-282">
            <div className="flex flex-col gap-6" data-id="element-283">
              <nav className="flex flex-col gap-4" data-id="element-284">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-serif text-matambrito-cream hover:text-matambrito-gold transition-colors border-b border-matambrito-charcoal pb-4" data-id="element-285">
                    {link.name}
                  </a>)}
              </nav>
              <div className="flex flex-col gap-4 mt-4" data-id="element-286">
                <a href="#contacto" onClick={() => setIsMobileMenuOpen(false)} className="bg-matambrito-red-fire text-white text-center px-6 py-4 rounded-md font-medium text-lg" data-id="element-287">
                  Reservar Mesa
                </a>
                <a href={deliveryUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-amber-600 text-white px-6 py-4 rounded-md font-medium text-lg" data-id="element-288">
                  <Truck className="w-6 h-6" data-id="element-289" />
                  Delivery
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}